var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRocketMenu = function SvgRocketMenu(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "rocketMenu_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#rocketMenu_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.1 10.125a18 18 0 0 1 3.021-5.041l-1.083-.23a1.6 1.6 0 0 0-.813.042 1.7 1.7 0 0 0-.687.417L2.913 7.938a.82.82 0 0 0-.24.75.75.75 0 0 0 .49.604zM17.35 2a8.6 8.6 0 0 0-4.198.855A12.9 12.9 0 0 0 9.6 5.375a13.4 13.4 0 0 0-1.76 2.167A17 17 0 0 0 6.517 10q-.104.271-.104.553 0 .28.208.49l2.604 2.603a.67.67 0 0 0 .49.209q.28 0 .552-.105 1.291-.563 2.458-1.322a13.4 13.4 0 0 0 2.167-1.76 12.9 12.9 0 0 0 2.52-3.553 8.6 8.6 0 0 0 .855-4.198.74.74 0 0 0-.083-.333 1.1 1.1 0 0 0-.209-.292 1.1 1.1 0 0 0-.291-.208A.74.74 0 0 0 17.35 2M12.06 8.21a1.6 1.6 0 0 1-.48-1.177q0-.699.48-1.177a1.6 1.6 0 0 1 1.177-.48 1.6 1.6 0 0 1 1.177.48q.48.479.479 1.177a1.6 1.6 0 0 1-.48 1.177 1.6 1.6 0 0 1-1.176.479 1.6 1.6 0 0 1-1.177-.48m-1.917 6.958.833 1.938a.77.77 0 0 0 .604.5.79.79 0 0 0 .75-.23l2.625-2.625a1.66 1.66 0 0 0 .417-.697q.125-.407.042-.823l-.209-1.084a19 19 0 0 1-2.406 1.719q-1.26.76-2.656 1.302m-6.77-1.792a2.45 2.45 0 0 1 1.77-.74 2.38 2.38 0 0 1 1.77.72 2.4 2.4 0 0 1 .73 1.77q0 1.042-.73 1.771a4.05 4.05 0 0 1-2.364 1.188l-2.74.375q.188-1.375.386-2.74a4.06 4.06 0 0 1 1.177-2.344"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRocketMenu);
export default ForwardRef;